import { GlossarySection as GlossarySectionType } from '../../GlossarySidebar.types'
import { GlossarySubSection } from '../GlossarySubSection'
import * as S from './GlossarySection.styles'

interface GlossarySectionProps {
  section: GlossarySectionType
  searchTerm?: string
}

export function GlossarySection({ section, searchTerm }: GlossarySectionProps) {
  return (
    <S.SectionContainer data-section-id={section.id}>
      <S.SectionHeader>
        <S.SectionTitleWrapper>
          <S.SectionTitle>{section.title}</S.SectionTitle>
          {section.description ? (
            <S.SectionDescription>{section.description}</S.SectionDescription>
          ) : null}
        </S.SectionTitleWrapper>
        {section.icon ? <S.IconWrapper>{section.icon}</S.IconWrapper> : null}
      </S.SectionHeader>

      {section.subsections && section.subsections.length > 0 ? (
        <S.SubsectionsWrapper>
          {section.subsections.map(subsection => (
            <GlossarySubSection
              key={subsection.id}
              subsection={subsection}
              searchTerm={searchTerm}
            />
          ))}
        </S.SubsectionsWrapper>
      ) : null}
    </S.SectionContainer>
  )
}
